import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { renderUserAvatar } from "@/lib/avatar";
import { useAuth } from "@/lib/auth.jsx";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

function timeStr(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  } catch { return ""; }
}

/** Right-drawer thread panel — parent message + replies + composer. */
export default function ThreadPanel({ msgId }) {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const [text, setText] = useState("");

  useEffect(() => {
    api.get(`/messages/${msgId}/thread`).then((r) => setData(r.data));
  }, [msgId]);

  const send = async () => {
    if (!text.trim()) return;
    const parent = data.parent;
    const r = await api.post(`/channels/${parent.channel_id}/messages`, {
      text, parent_id: parent.id,
    });
    setData((d) => ({ ...d, replies: [...d.replies, { ...r.data, user }] }));
    setText("");
  };

  if (!data) return <div className="p-4 text-sm text-zinc-500">Loading…</div>;
  return (
    <div className="p-3">
      <div className="border rounded-md p-3 mb-3 bg-zinc-50">
        <div className="text-xs text-zinc-500">
          {data.parent.user?.name} · {timeStr(data.parent.created_at)}
        </div>
        <div className="text-sm">{data.parent.text}</div>
      </div>
      <div className="space-y-2">
        {data.replies.map((r) => (
          <div key={r.id} className="flex gap-2">
            <img src={renderUserAvatar(r.user)} className="w-7 h-7 rounded-full object-cover" alt=""/>
            <div>
              <div className="text-xs text-zinc-500">{r.user?.name} · {timeStr(r.created_at)}</div>
              <div className="text-sm">{r.text}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-3 flex gap-2">
        <Input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Reply…"
          data-testid="thread-input"
          onKeyDown={(e) => e.key === "Enter" && send()}
        />
        <Button onClick={send} data-testid="thread-send" size="sm">Send</Button>
      </div>
    </div>
  );
}
